/**
 *
 * @param definition
 */
export function getDefinitionKey(definition) {
    var _a;
    return (_a = definition.definitionKey) !== null && _a !== void 0 ? _a : '';
}
